import axios from "axios";

export default {
    DOWNLOAD_COOPERATIVES_CSV_URL: "adminuserListByMultipleRoles/download-csv",

    async getCoorporativeLists(params = {}) {
        var url = `adminuserListByMultipleRoles`;
        return await axios
          .get(url, {
            params: {
              ...params
            },
          })
          .then(({ data }) => data)
          .catch((error) => Promise.reject(error));
      },
      async getCooperativeDetails(id) {
        return await axios.get(`user/${id}/detail`)
          .then(({ data }) => data)
          .catch((error) => Promise.reject(error));
      },

      async deactivateCooperative(id, status) {
        return await axios.patch(`user/${id}/status/${status}`)
          .then(({ data }) => data)
          .catch((error) => Promise.reject(error));
      },
      
      async deleteCooperative(id) {
        return await axios.delete(`user/${id}`)
          .then(({ data }) => data)
          .catch((error) => Promise.reject(error));
      },

      async addCooperative(data) {
        return await axios.post(`user`, data)
          .then(({ data }) => data)
          .catch((error) => Promise.reject(error));
      },
      
      async updateCooperative(id, data) {
        return await axios.put(`user/${id}`, data)
          .then(({ data }) => data)
          .catch((error) => Promise.reject(error));
      },

      async getCooperativeFarms(cooperativeId, params = {}) {
        return await axios
          .get(`download-cooperatives-farms/${cooperativeId}`, { params })
          .then(({ data }) => data)
          .catch((error) => Promise.reject(error));
      },
}